<button (click)="toggleDropdown()" class="dropdown-button text-btn" [ngClass]="{'show': showDropdown}">
  <span class="text-white">{{ label }}</span>
  <div class="icon-chips"></div>
</button>

<div [ngClass]="{'show': showDropdown}" class="dropdown-menu">

  <mat-chip-listbox (change)="onSelectionChange($event)">
      <ng-container *ngFor="let item of _dataSource$ | async as items">
          <mat-chip-option  [value]="item.value" class="text-btn">{{ item.label }} </mat-chip-option>
      </ng-container>
  </mat-chip-listbox>

</div>
